//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StepLayout from './step-layout.vue';
import Button from '../components/button.vue';
import Radio from '../components/radio.vue';
import stepMixin from '../lib/step-mixin.js';

export default {
  components: {
    StepLayout,
    Button,
    Radio
  },
  mixins: [stepMixin],
  props: {
    houseType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    selected: '',
    loading: false
  }),
  created() {
    if (this.houseType) this.selected = this.houseType;
  },
  methods: {
    onContinue() {
      this.loading = true;
      this.$emit('continue', { house_type: this.selected });
    }
  }
};
